import { MYNAVI_PRIMARY } from '@/components/Campaign/mynavi/Color'
import { MyNaviButton } from '@/components/Campaign/mynavi/MyNaviButton/MyNaviButton'
import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { EmailInputSchema } from '@/schemas/forms/emailRegistration'
import type { EmailInputFormData } from '@/schemas/forms/emailRegistration'
import { zodResolver } from '@hookform/resolvers/zod'
import { Modal } from '@mantine/core'
import { useForm } from 'react-hook-form'

type Props = {
  opened: boolean
  isLoading: boolean
  errorMessage: string | null
  title?: string
  onSubmit: (email: string) => void
  onCancel: () => void
}

export const DialogEmailInput = ({
  opened,
  isLoading,
  errorMessage,
  title = 'メールアドレス登録',
  onSubmit,
  onCancel,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<EmailInputFormData>({
    resolver: zodResolver(EmailInputSchema),
  })

  const handleClose = () => {
    reset()
    onCancel()
  }

  const handleFormSubmit = (data: EmailInputFormData) => {
    onSubmit(data.email)
  }

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      withCloseButton={!isLoading}
      closeOnClickOutside={!isLoading}
      closeOnEscape={!isLoading}
      centered
      size="md"
      radius="lg"
      lockScroll
      styles={{
        header: { justifyContent: 'center', paddingBottom: 8 },
        title: { flex: 1 },
        close: { '& svg': { strokeWidth: 3 } },
      }}
      title={
        <MyNaviTypography variant="dialog-title" as="p" className="text-center m-0" style={{ color: MYNAVI_PRIMARY }}>
          {title}
        </MyNaviTypography>
      }
    >
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="flex flex-col gap-4 pb-2">
          <div style={{ lineHeight: 1.35 }}>
            <MyNaviTypography variant="search-hint" as="p" className="m-0">
              メールアドレスを入力してください。
            </MyNaviTypography>
            <MyNaviTypography variant="search-hint" as="p" className="m-0">
              ※ドメイン指定受信を設定している場合は
              <br />
              　@raund.netの受信設定をして下さい
            </MyNaviTypography>
          </div>
          <input
            id="email-input"
            type="email"
            autoComplete="email"
            aria-label="メールアドレス"
            style={{
              border: '1px solid #686868',
              borderRadius: '5px',
              height: '42px',
              padding: '0 12px',
              fontSize: '16px',
              fontFamily: "'Noto Sans JP', sans-serif",
              width: '100%',
              backgroundColor: '#fbfbfb',
            }}
            {...register('email')}
          />
          {errors.email && <p className="text-xs text-red-500">{errors.email.message}</p>}
          {errorMessage && <p className="text-xs text-red-500 text-center">{errorMessage}</p>}
          <MyNaviButton
            label={isLoading ? '送信中...' : '登録する'}
            showIcon={false}
            onClick={handleSubmit(handleFormSubmit)}
            fullWidth
          />
          <div className="flex justify-center">
            <button
              type="button"
              onClick={handleClose}
              disabled={isLoading}
              style={{
                fontSize: '15px',
                color: MYNAVI_PRIMARY,
                textDecoration: 'underline',
                fontFamily: "'Noto Sans JP', sans-serif",
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
              }}
              className="disabled:opacity-50 disabled:cursor-not-allowed"
            >
              キャンセル
            </button>
          </div>
        </div>
      </form>
    </Modal>
  )
}
